
        var result = require("!!../../../../node_modules/css-loader/index.js!./stock-overview.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/stock/stock-overview/stock-overview.component.css
// module id = 2471
// module chunks = 1